import styled from "styled-components";

export const ToolContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 2px 10px;
`;

export const ToolWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 4px;
  padding: ${({ isSelected }) => {
    return isSelected ? "2px;" : "4px;";
  }};
  background-color:  ${({ backgroundColor }) => {
    return backgroundColor ? backgroundColor : "#f0f0f0";
  }};
  border-radius: 4px;
  cursor: pointer;
  border: ${({ isSelected }) => {
    return isSelected ? `2px solid rgb(0, 120, 66);` : "none;";
  }};
  z-index: 1;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%; /* Below the button */
  left: 0;
  background: #ffffff;
  border: 1px solid #d3d3d3;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 9999;
  padding: 0 0;
  width: 120px;

  & > div {
    padding: 8px 16px;
    cursor: pointer;
    font: normal normal normal 14px/19px Open Sans;
    color: #707070;
    &:hover {
      background-color: #f0f0f0;
    }
  }
`;